import React, { Component } from 'react';
import './AccountOptions.css';
import FontIcon from '../fontIcon/FontIcon';
import Label from '../label/Label';
import models from '../../model/models';
import history from '../../history';
import classNames from 'classnames';

export default class AccountOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openMenu: false,
			user: models.user.getCurrent()
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.user.onCurrentChange(this._setUser);
		this.subscribeGroupId = models.user_group.onChange(this._setUser);
		this._setUser();

		this.handleOutsideClick = (event) => {
			if (this.state.openMenu) {
				const menuElement = this.menuRef;
				const accountButtonElement = this.accountButtonRef;
				
				if (
					menuElement &&
					accountButtonElement &&
					!menuElement.contains(event.target) &&
					!accountButtonElement.contains(event.target)
				) {
					setTimeout(this._closeMenu, 100);
				}
			}
		};

		document.body.addEventListener('click', this.handleOutsideClick, true);
	};

	componentWillUnmount = () => {
		models.user.unsubscribe(this.subscribeId);
		models.user_group.unsubscribe(this.subscribeGroupId);
		if (this.handleOutsideClick) {
			document.body.removeEventListener('click', this.handleOutsideClick, true);
		}
	};

	_setUser = () => {
		this.setState({ user: models.user.getCurrent(), userGroup: models.user_group.obj() });
	};

	_toggleMenu = () => {
		this.setState({ openMenu: !this.state.openMenu });
	};

	_closeMenu = () => {
		this.setState({ openMenu: false });
	};

	_logout = () => {
		delete localStorage.token;
		delete localStorage.user_group_id;
		delete localStorage.num_additional_groups;
		localStorage.clear();
		this._closeMenu();
		history.navigate('/login');
	};

	_navigateSettings = () => {
		this._closeMenu();
		history.navigate('/settings/general');
	};

	_navigateSuperAdminSettings = () => {
		this._closeMenu();
		history.navigate('/super/admin/settings');
	};

	canSelectWithTab = () => {
		if(!localStorage.token) return -1;
		else if(localStorage.token){
			return 0;
		}
		else{
			return -1;
		}
	}

	_renderSuperAdminLink = () => {
		// return null;
		let { user = {} } = this.state;
		if (user.role === 'super_admin') {
			return (
				<div
					tabIndex={this.canSelectWithTab()}
					className="options-item"
					onClick={this._navigateSuperAdminSettings}
				>
					Super Admin Settings
				</div>
			);
		}
	};

	render() {
		let user = this.state.user || {};
		let userGroup = this.state.userGroup || {};
		return (
			<div className="g-account-options">
				<div 
					ref={(ref) => { this.menuRef = ref; }}
					className={classNames('options-menu', { 'menu-open': this.state.openMenu })}
				>
					<div
						ref={(ref) => { this.accountButtonRef = ref; }}
						tabIndex={this.canSelectWithTab()}
						className="options-menu"
						onClick={this._toggleMenu}
					>
						<Label tabIndex={this.canSelectWithTab()} blue={this.state.openMenu} gray-medium={!this.state.openMenu}>
							Account <FontIcon name="icon-chevron-right" />
						</Label>
					</div>
					<Label black bold className="options-name">
						{user.first_name + ' ' + user.last_name}
					</Label>
					<Label gray-dark className="g-account-options-email">
						{user.primary_email}
					</Label>
					<Label medium-small className="g-account-options-agency">
						{userGroup.name}
					</Label>
					<div className="options-divider"></div>
					<div
						tabIndex={this.canSelectWithTab()}
						className="options-item"
						onClick={this._navigateSettings}
					>
						Settings
					</div>
					{this._renderSuperAdminLink()}
					<div
						tabIndex={this.canSelectWithTab()}
						className="options-item"
						onClick={this._logout}
					>
						Log-out
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/accountOptions/AccountOptions.jsx